import React, { useEffect, useState } from "react";
import { loadTableTheme, saveTableTheme, themeStyleVars, DEFAULT_TABLE_THEME } from "../utils/tableTheme";

export default function TableStyleEditor({ onDirtyChange, setSaveHandler }) {
    const [form, setForm] = useState(loadTableTheme());
    const [saving, setSaving] = useState(false);

    // branchement au mécanisme "unsaved" du parent
    useEffect(() => {
        onDirtyChange?.(false);
        const save = async () => {
            setSaving(true);
            await saveTableTheme(form);
            setSaving(false);
            onDirtyChange?.(false);
        };
        setSaveHandler?.(save);
        return () => setSaveHandler?.(null);
        // eslint-disable-next-line
    }, [form]);

    const markDirty = (next) => { setForm(next); onDirtyChange?.(true); };
    const setField = (k) => (e) => markDirty({ ...form, [k]: e.target.value });
    const reset = () => markDirty(DEFAULT_TABLE_THEME);

    const doSave = async () => {
        setSaving(true);
        await saveTableTheme(form);
        setSaving(false);
        onDirtyChange?.(false);
    };

    const vars = themeStyleVars(form);
    const headers = ["N°", "Désignation", "Qté", "PU HT", "TVA", "Total HT"];

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <label className="text-sm">
                    <div className="mb-1 text-slate-600">Fond de l’en-tête</div>
                    <input type="color" value={form.headerBg} onChange={setField("headerBg")} className="h-9 w-full cursor-pointer" />
                </label>
                <label className="text-sm">
                    <div className="mb-1 text-slate-600">Texte de l’en-tête</div>
                    <input type="color" value={form.headerText} onChange={setField("headerText")} className="h-9 w-full cursor-pointer" />
                </label>
                <label className="text-sm">
                    <div className="mb-1 text-slate-600">Lignes verticales</div>
                    <input type="color" value={form.vLine} onChange={setField("vLine")} className="h-9 w-full cursor-pointer" />
                </label>
            </div>

            <div className="text-xs text-slate-500">
                S’applique à la ligne d’en-tête (N°, Désignation, Qté, PU HT, TVA, Total HT) et aux lignes verticales.
            </div>

            {/* Aperçu */}
            <div className="border rounded-md overflow-hidden" style={vars}>
                <table className="w-full text-sm">
                    <thead>
                        <tr>
                            {headers.map((h, i) => (
                                <th key={h}
                                    className="px-3 py-2 text-left font-semibold"
                                    style={{
                                        background: "var(--doc-th-bg)",
                                        color: "var(--doc-th-text)",
                                        borderRight: i < headers.length - 1 ? "1px solid var(--doc-vline)" : "none",
                                    }}>
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {[1, 2].map(r => (
                            <tr key={r}>
                                {headers.map((_, i) => (
                                    <td key={i} className="px-3 py-2"
                                        style={{ borderRight: i < headers.length - 1 ? "1px solid var(--doc-vline)" : "none" }}>
                                        —
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="flex items-center gap-2">
                <button
                    type="button"
                    className="inline-flex items-center rounded-full bg-sky-700 px-4 py-2 text-sm text-white shadow hover:bg-sky-600"
                    onClick={doSave}
                    disabled={saving}
                >
                    {saving ? "Enregistrement..." : "Enregistrer"}
                </button>
                <button
                    type="button"
                    className="inline-flex items-center rounded-full border border-slate-300 bg-white px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
                    onClick={reset}
                    disabled={saving}
                >
                    Réinitialiser
                </button>
            </div>
        </div>
    );
}
